import cx from 'classnames';
import PropTypes from 'prop-types';

import defaultLogoImage from '@app/assets/logos/logo-service-email-default.jpg';
import { LATEST_PRIVACY_URL, LATEST_SERVICE_URL } from '@app/constants/terms';

import './EmailPreview.scss';

const propTypes = {
  borderColor: PropTypes.string,
  buttonTextColor: PropTypes.string,
  buttonBackgroundColor: PropTypes.string,
  isCustom: PropTypes.bool,
  logo: PropTypes.shape({
    base64: PropTypes.string,
    height: PropTypes.number,
    link: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
  }),
  serviceDescription: PropTypes.string,
};

const defaultProps = {
  borderColor: '',
  buttonTextColor: '',
  buttonBackgroundColor: '',
  isCustom: false,
  logo: {
    height: 0,
    link: '',
    url: '',
    width: 0,
  },
  serviceDescription: ' ',
};

function EmailPreview(props) {
  const {
    borderColor,
    buttonTextColor,
    buttonBackgroundColor,
    isCustom,
    logo: { base64, height, link, url, width },
    serviceDescription,
  } = props;

  return (
    <div
      className={cx({
        EmailPreview: true,
        'EmailPreview--custom': isCustom,
      })}
    >
      <div className="EmailPreview__background">
        <div className="EmailPreview__container">
          <div
            className="EmailPreview__main-box space-2x"
            style={{ borderTop: `4px solid ${borderColor}` }}
          >
            <div className="EmailPreview__header-box">
              <table className="EmailPreview__header">
                <tbody>
                  <tr>
                    <td>
                      <a href={link} rel="noopener noreferrer" target="_blank">
                        <img
                          alt="로고 이미지"
                          height={height}
                          src={base64 || url || defaultLogoImage}
                          width={width}
                        />
                      </a>
                    </td>
                    <td className="align-right">{serviceDescription}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="EmailPreview__body align-center">
              <div className="EmailPreview__title-box">
                <div className="EmailPreview__title">서명할 차례 입니다.</div>
                <p className="EmailPreview__description">
                  서명 정보를 확인해 주세요.
                  <br />
                  아래 버튼을 누르면 서명할 수 있는 페이지로 이동합니다.
                </p>
              </div>
              <div className="EmailPreview__content-box">
                <table className="EmailPreview__info-table">
                  <tbody>
                    <tr>
                      <td className="EmailPreview__info-table-row">
                        <table>
                          <tbody>
                            <tr>
                              <th className="EmailPreview__info-table-th">문서 이름</th>
                              <td className="EmailPreview__info-table-td">홍길동 연봉 계약서</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td className="EmailPreview__info-table-row">
                        <table>
                          <tbody>
                            <tr>
                              <th className="EmailPreview__info-table-th">서명 요청자</th>
                              <td className="EmailPreview__info-table-td">
                                김민수 (kim@modusign.co.kr)
                              </td>
                            </tr>
                            <tr>
                              <th className="EmailPreview__info-table-th">서명자</th>
                              <td className="EmailPreview__info-table-td">
                                1. 홍길동 (hong@modusign.co.kr)
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="EmailPreview__button-box">
                <div
                  className="EmailPreview__main-button"
                  style={{
                    color: buttonTextColor,
                    backgroundColor: buttonBackgroundColor,
                  }}
                >
                  <b>내용 확인하고 서명하기</b>
                </div>
              </div>
            </div>
          </div>
          <div className="EmailPreview__sub-box">
            <div className="EmailPreview__sub-box-content">
              <div className="EmailPreview__sub-box-title">이메일과 링크를 공유하지 마십시오.</div>
              <p className="EmailPreview__sub-box-paragraph">
                본 메일과 링크를 공유할 경우, 승인하지 않은 제 3자가 내용을 확인하고 서명할 수
                있습니다. 이때 발생하는 문제에 대해서 모두싸인은 책임지지 않습니다.
              </p>
              <div className="EmailPreview__sub-box-title">이메일 계정을 삭제하지 마십시오.</div>
              <p className="EmailPreview__sub-box-paragraph">
                서명 진행과 관련된 중요한 내용이 메일로 전송됩니다. 메일 삭제, 수신 거부 등 사용자의
                귀책사유로 메일이 전송되지 않아 발생하는 문제에 대해 모두싸인은 책임지지 않습니다.
              </p>
              <div className="EmailPreview__sub-box-title">안심하고 이용하세요.</div>
              <p className="EmailPreview__sub-box-paragraph">
                전자적 방식이라는 이유로 전자 서명, 전자 문서의 법적 효력이 부인되지 않습니다.{' '}
                (전자서명법, 전자문서 및 전자거래 기본법 등), 서명 진행간 주요한 정보(시간, 아이피
                주소 등)은 모두싸인 감사로그에 기록되며 당사자의 행위를 증명할 수 있습니다. 모든
                데이터는 암호화하여 전송되고 안전하게 저장됩니다.
              </p>
            </div>
          </div>
          <div className="EmailPreview__footer align-center">
            <p>
              본 메일은 발신 전용으로 회신이 되지 않습니다.
              <br />
              문의는{' '}
              <a
                className="EmailPreview__footer-underline-link"
                href="https://support.modusign.co.kr"
                rel="noopener noreferrer"
                target="_blank"
              >
                고객센터
              </a>
              를 이용해주세요.
              <br />
              <br />© 2016-{new Date().getFullYear()}. Modusign Inc. All rights reserved.
              <br />
              <a href={LATEST_SERVICE_URL} rel="noopener noreferrer" target="_blank">
                이용약관
              </a>
              {' | '}
              <a href={LATEST_PRIVACY_URL} rel="noopener noreferrer" target="_blank">
                <b>개인정보처리방침</b>
              </a>
              {' | '}
              <a href="https://support.modusign.co.kr" rel="noopener noreferrer" target="_blank">
                고객센터
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

EmailPreview.propTypes = propTypes;
EmailPreview.defaultProps = defaultProps;

export default EmailPreview;
